<template>
  <div>
    <oil-form v-if='loading'
              :title='formTitle.toUpperCase()'
              :keys='keys'
              :items='act'
              :createForm='true'
              :formCallback='formCallBack'
    >
      <template v-slot:Buyer.Id='{rules}'>
        <v-autocomplete
            :items='buyers$'
            v-stream:keyup.native='searchCompany$'
            hide-no-data
            class='z-index'
            clearable
            :rules='[...rules]'
            dense
            outlined
            @change='changeBuyer'
            hide-selected
            :value='act.Buyer.CompanyName'
            item-text='CompanyName'
            label='Выбрать покупателя'
            return-object
        ></v-autocomplete>
      </template>
      <template v-slot:Contract.Id='{rules}'>
        <v-autocomplete
            :items='contracts$'
            v-stream:keyup.native='searchContract$'
            hide-no-data
            class='z-index'
            :rules='[...rules]'
            clearable
            @change='changeContract'
            dense
            outlined
            :value='act.Contract.Number'
            hide-selected
            item-text='Number'
            label='Выбрать договор'
            return-object
        ></v-autocomplete>
      </template>
      <template v-slot:Status="{rules}">
        <v-select
            v-model="act.Status"
            :items="statuses"
            outlined
            dense
            label="Статус"
            :rules='[checkedStatus]'
            return-object
            multiple
        >
          <template v-slot:prepend-item>
            <v-list-item
                ripple
                @click="toggle"
            >
              <v-list-item-action>
                <v-icon :color="act.Status.length > 0 ? 'indigo darken-4' : ''">
                  {{ icon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Все
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </template>

    </oil-form>
  </div>
</template>

<script>
import {actService} from '@/services/actService'
import {form} from '@/pages/setting/act_calculation_create.json'
import {companiesService} from '@/services/CompaniesService'
import {contractsService} from '@/services/ContractsService'
import {debounceTime, distinctUntilChanged, filter, pluck, switchMap} from 'rxjs/operators'
import {coreApi} from '@/services/core'

export default {
  components: {
    OilForm: () => import('@/components/helper/oil.form')
  },
  data: () => ({
    loading: false,
    formTitle: 'Создать расчет',
    keys: form.keys,
    act: {
      Number: '',
      StartDate: '',
      EndDate: '',
      Buyer: {
        Id: ''
      },
      Contract: {
        Id: '',
        Number: ''
      },
      Status: []
    },
    acts: [],
    companies: [],
    contracts: [],
    contractsStore: [],
    statuses: [
      {value: 'active', text: 'Активный'},
      {value: 'notsigned', text: 'Неподписанный'},
      {value: 'special', text: 'Особый'},
      {value: 'inactive', text: 'Неактивный'},
    ]
  }),
  domStreams: ['searchCompany$', 'searchContract$'],
  subscriptions() {
    return {
      contracts$: this.searchContract$.pipe(
          pluck('event', 'target', 'value'),
          debounceTime(200),
          distinctUntilChanged(),
          switchMap(query => coreApi.get(`contract/search/number?pattern=${query}`)),
          pluck('data')
      ),
      buyers$: this.searchCompany$.pipe(
          pluck('event', 'target', 'value'),
          debounceTime(200),
          filter(value => value.length > 2),
          debounceTime(100),
          distinctUntilChanged(),
          switchMap(query => coreApi.get(`company/search/name?pattern=${query}`)),
          pluck('data')
      )
    }
  },
  async created() {
    this.contracts$ = []
    const companies = await companiesService.getAll()
    this.buyers$ = companies.data?.filter(({IsActive}) => IsActive === true)
    const seller = await companiesService.seller()
    const {
      CompanyName,
      Address
    } = seller.data
    this.act.SellerInfo = `${CompanyName} ${Address}`

    this.loading = true
  },
  computed: {
    storeType() {
      return this.id ? actService.actCalculateUpdate : actService.actCalculateCreate
    },

    likesAllFruit() {
      return this.statuses.length === this.act.Status.length
    },
    likesSomeFruit() {
      return this.statuses.length > 0 && !this.likesAllFruit
    },
    icon() {
      if (this.likesAllFruit) return 'mdi-close-box'
      if (this.likesSomeFruit) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },

  },
  methods: {
    checkedStatus(status) {
      return this.act.Status.length > 0 || 'Поле обязательно для ввода'
    },
    async changeBuyer(buyer) {
      if (!buyer) return
      this.act.Buyer = {...buyer}
      const contracts = await contractsService.contractCompanyById({companyId: buyer?.Id})
      this.contractsStore = contracts.data
    },
    changeContract(contract) {
      if (!contract) return
      this.act.Contract = {...contract}
      this.act.Buyer = {...contract.Buyer}
    },
    /**
     *
     * @param Status {Array}
     */
    formatStatus({Status}) {
      this.act.Status = Status.map(status => status.value)
    },
    async formCallBack(data, input) {

      this.formatStatus(data)

      input.isEdit = false
      const response = await actService.actCalculateCreate(data)
      const id = response.data
      if (!id) {
        input.isEdit = true
        return
      }
      input.isEdit = true
      this.contracts$ = []
      this.act.Buyer = {Id: ''}
      this.act.Contract = {Id: '', Number: ''}
      this.act.Number = ''
      this.act.Status = []
      await this.showMePdf('act/print', id)
    },
    openPdf(id, path) {
      window.open(process.env.VUE_APP_BACKEND_API + `/${path}/${id}`)
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllFruit) {
          this.act.Status = []
        } else {
          this.act.Status = this.statuses.slice()
        }
      })
    },
  },
  watch: {
    companies(companies) {
      this.keys['Buyer.Id'].attrs.items = companies
      this.buyers$ = companies
    },
    contractsStore(contractsStore) {
      this.contracts = contractsStore
    },
    contracts(contracts) {
      this.keys['Contract.Id'].attrs.items = contracts
      this.contracts$ = contracts
    },
    'act': {
      handler(act) {
        this.contracts = this.contractsStore.filter(({Status}) => {
          const len = act.Status.filter(({value}) => value === Status).length
          return len > 0
        })
      },
      deep: true
    }
  }
}
</script>
